// extracted by mini-css-extract-plugin
module.exports = {"azure_solid_button":"AzureSolidButton_azure_solid_button__ItgEc"};